import React from "react";
import { Star, MapPin, Clock } from "lucide-react";
import { foodTypes } from "../functions/mini_func";

interface RestaurantCardProps {
  restaurant: {
    dbID: string;
    name: string;
    image?: string;
    restRating?: string;
    storeType?: string;
    distance?: number;
    distanceText?: string;
    openingTime?: string;
    closingTime2?: string;
    durationText?: string;
  };
  onClick?: () => void;
  showRouteIndicator?: boolean;
  className?: string;
}

export const RestaurantCard: React.FC<RestaurantCardProps> = ({
  restaurant,
  onClick,
  showRouteIndicator = false,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full bg-white/5 hover:bg-gray-900 rounded-xl p-4 transition-colors text-left ${className}`}
      aria-label={`View ${restaurant.name} details`}
    >
      <div className="flex gap-4">
        {/* Restaurant Image */}
        {restaurant.image && (
          <div className="w-24 h-24 rounded-lg overflow-hidden flex-shrink-0">
            <img
              src={restaurant.image}
              alt={restaurant.name}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Restaurant Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="text-white font-semibold text-base truncate">
              {restaurant.name}
            </h3>
            {restaurant.restRating !== undefined && restaurant.restRating !== "0" && (
              <div className="flex items-center gap-1 bg-[#1a1a1a] px-2 py-1 rounded-full flex-shrink-0">
                <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
                <span className="text-white text-xs font-medium">
                  {restaurant.restRating}
                </span>
              </div>
            )}
          </div>

          {/* Store Type */}
          {restaurant.storeType && (
            <p className="text-gray-400 text-sm mb-2 line-clamp-2">
              {foodTypes(restaurant)}
            </p>
          )}

          {/* Distance and Timings */}
          <div className="flex items-center gap-4 text-xs text-gray-500">
            {restaurant.distance !== undefined && (
              <div className="flex items-center justify-between w-full gap-1">
                <div className="flex items-center gap-1">
                  <MapPin className="w-3 h-3" />
                  <span>
                    {restaurant.distanceText ||
                      `${restaurant.distance.toFixed(1)} km`}
                    {showRouteIndicator && (
                      <span className="text-green-400 ml-1">from start</span>
                    )}
                  </span>
                </div>
                {restaurant.durationText && (
                  <span className="text-green-500">
                    {restaurant.durationText
                      .replace("ours", "")
                      .replace("ins", "")}
                  </span>
                )}
              </div>
            )}
            {/* {restaurant.openingTime && restaurant.closingTime2 && (
              <div className="flex items-center gap-1">
                <Clock className="w-3 h-3" />
                <span>
                  {restaurant.openingTime} - {restaurant.closingTime2}
                </span>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </button>
  );
};
